import { call, put, takeLatest } from "redux-saga/effects";
import {
  DELETE_CASHBOOK_ENTRY_ID,
  EDIT_CASHBOOK_ENTRY_ID,
  GET_CASHBOOK_ENTRY_LIST,
  GET_CASHBOOK_PARTY_HEADS,
  SAVE_CASHBOOK_PARTY_HEAD,
  UPDATE_CASHBOOK_ENTRY_ID,
} from "./actionTypes";
import {
  CashBookEntry_CreatePartyHead_API,
  CashBookEntryPostAPI,
  CashBookEntryDeleteAPI,
  CashBookHead_POST_API,
} from "../../../helpers/backend_helper";
import {
  cashBookEntryApiErrorAction,
  deleteCashBookEntryIDSuccess,
  editCashBookEntryIDSuccess,
  getCashBookEntryListSuccess,
  getCashBookPartyHeadsSuccess,
  saveCashBookPartyHead_Success,
  updateCashBookEntryIDSuccess,
} from "./action";

const formatDMY = (value) => {
  if (!value) return value;
  const m = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}-${m[2]}-${m[1]}` : value;
};

function* Get_CashBook_PartyHeads_GenFun({ partyId }) {      // body { PartyID, CashierID, Date } arrives in "partyId"
  try {
    const response = yield call(CashBookHead_POST_API, JSON.stringify(partyId));
    yield put(getCashBookPartyHeadsSuccess(Array.isArray(response?.Data) ? response.Data : []));
  } catch (error) {
    yield put(getCashBookPartyHeadsSuccess([]));      // clear stale list
    yield put(cashBookEntryApiErrorAction());
  }
}
  function* Save_CashBook_PartyHead_GenFun({ config }) {       // save party head
    try {
      const response = yield call(CashBookEntry_CreatePartyHead_API, config);
      yield put(saveCashBookPartyHead_Success(response));
    } catch (error) { yield put(cashBookEntryApiErrorAction()) }
  }

  function* Get_CashBook_Entry_List_GenFun({ config }) {      // get entry list
    try {
      const response = yield call(CashBookEntryPostAPI, config);
      const records = (response?.Data?.Records || []).map((row) => ({
        ...row,
        Date: formatDMY(row.Date),
      }));
      yield put(getCashBookEntryListSuccess(records));
    } catch (error) { yield put(cashBookEntryApiErrorAction()) }
  }

  function* Edit_CashBook_Entry_GenFun({ config }) {      // edit entry
    try {
      const response = yield call(CashBookEntryPostAPI, config);
      response.pageMode = config.btnmode;
      yield put(editCashBookEntryIDSuccess(response));
    } catch (error) { yield put(cashBookEntryApiErrorAction()) }
  }

  function* Update_CashBook_Entry_GenFun({ config }) {      // update entry
    try {
      const response = yield call(CashBookEntry_CreatePartyHead_API, config);   // was CashBookEntryPostAPI
      yield put(updateCashBookEntryIDSuccess(response));
    } catch (error) { yield put(cashBookEntryApiErrorAction()) }
  }

  function* Delete_CashBook_Entry_GenFun({ config }) {
    try {
      const response = yield call(CashBookEntryDeleteAPI, config);
      yield put(deleteCashBookEntryIDSuccess(response));
    } catch (error) {
      yield put(cashBookEntryApiErrorAction());
    }
  }

  function* CashBookEntrySaga() {
    yield takeLatest(GET_CASHBOOK_PARTY_HEADS, Get_CashBook_PartyHeads_GenFun)
    yield takeLatest(SAVE_CASHBOOK_PARTY_HEAD, Save_CashBook_PartyHead_GenFun)
    yield takeLatest(GET_CASHBOOK_ENTRY_LIST, Get_CashBook_Entry_List_GenFun)
    yield takeLatest(EDIT_CASHBOOK_ENTRY_ID, Edit_CashBook_Entry_GenFun)
    yield takeLatest(UPDATE_CASHBOOK_ENTRY_ID, Update_CashBook_Entry_GenFun)
    yield takeLatest(DELETE_CASHBOOK_ENTRY_ID, Delete_CashBook_Entry_GenFun);
  }

  export default CashBookEntrySaga;